<template>
  <business-location-details />
</template>
<script>
import BusinessLocationDetails from './components/BusinessLocationDetails.vue';

export default {
  components: {
    BusinessLocationDetails
  },
  data: function() {
    return {
      helpText: 'Area Name & City are really important to find the right audience',
      animation: {
        smTop: '-5px',
        smWidth: '110px',
        width: 240,
        height: 240,
        smHeight: 110,
        smWidth: 110
      }
    };
  }
}
</script>